import React from 'react';
import { } from '../../img';  // GglIcon IconDelete
import ContentLoader from 'react-content-loader';

const DataSourceCard = ({
  lstActiveIntg,
  widgetById,
  state,
  arrDataSource,
  //selectDataSrc,
  handleDataSource,
  //handleIsLoader
  //widgetType
}) => {
  //Filter Integration by Widget type name
  if (lstActiveIntg && lstActiveIntg.length > 0 && widgetById) {
    lstActiveIntg = lstActiveIntg.filter(x => x.typ.indexOf(widgetById.wdtnm) !== -1);
  }

  //Sort Integration by A-Z or Z-A
  lstActiveIntg && lstActiveIntg.sort((a, b) => {
    if (a.dn < b.dn) {
      return -1;
    } if (a.dn > b.dn) {
      return 1;
    }
    return 0;
  });
  console.log(arrDataSource, '====arrDataSource');
  return (
    <div className="side-editor-panel side-editor-dataset">
      <div className="dataset-block">
        <div className="title-apps-block">
          <h5 className="h5 title-apps-integra">Apps and Integrations</h5>
        </div>
        <div className="apps-integra-all">
          {state.isLoaderDS === true ?
            <ContentLoader
              height={750}
              width={1750}
              speed={2}
              primaryColor="#fff"
              secondaryColor="#eceef4"
            >
              <rect x="150" y="40" rx="0" ry="0" width="1450" height="1000"></rect>
            </ContentLoader>
            :
            arrDataSource && arrDataSource.length > 0 ?
              arrDataSource.map((objDSIItems, objKey) => {
                let filterInt = lstActiveIntg.filter(x => x.in == objDSIItems.iin);
                if (filterInt.length > 0) {
                  let intName = filterInt[0].in;
                  if (
                    [
                      'twitterpost',
                      'facebook',
                      'googlereview',
                      'googleplace',
                      'capterra',
                      'booking',
                      'tripadvisor',
                      'trustpilot',
                      'airbnb',
                      'yelp',
                      'hotels',
                      'etsyreview',
                      'houzzreview',
                      'edmundsreview',
                      'dealerrater',
                      'opentablereview',
                      'ebay',
                      'bbb',
                      'amazon',
                      'googleplay',
                      'appleapp',
                      'facebookpost',
                      'instagrampost',
                      'rsspost',
                      'tumblrpost',
                      'appsumo',
                      'customreview',
                      'custom',
                      'aliexpressreview'
                    ].indexOf(intName) !== -1) {
                    return (
                      <div className="apps-integra-item" key={objKey} >
                        <div className="apps-integra-img">
                          <img src={filterInt[0].img} alt="" />
                        </div>
                        <span className="integra-add-title">{objDSIItems.rmk}</span>
                        <span
                          className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-30  tbl-action-dlt"
                          onClick={() => handleDataSource(objDSIItems.uid, objDSIItems.pid, false, {})}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 176 192">
                            <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                              <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                              <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                            </g>
                          </svg>
                        </span>
                      </div>
                    );
                  }
                }
              })
              :
              <div className="apps-integra-item">
                <span className="" style={{ margin: '0 auto' }}>No record found</span>
              </div>

          }
        </div>
      </div>
    </div>
  );
};

export default DataSourceCard;


// WEBPACK FOOTER //
// ./src/components/Widget/DataSourceCard.js